import { USState, USStateAbbreviated } from "../../../../../../lib/types"
import { initialFormState, MinimumWageStateI, MinimumWageTableI } from "./initialState"

interface SetRowsAction { type: 'SET_ROWS', payload: MinimumWageTableI[] }
interface SetSelectedRowAction { type: 'SET_SELECTED_ROW', payload: MinimumWageTableI }
interface SetFilteredStateAction { type: 'SET_FILTERED_STATE', payload: USState | 'All States' }
interface SetAddModalOpenAction { type: 'SET_ADD_MODAL_OPEN', payload?: any }
interface SetEditModalOpenAction { type: 'SET_EDIT_MODAL_OPEN', payload: MinimumWageTableI }
interface SetDeleteModalOpenAction { type: 'SET_DELETE_MODAL_OPEN', payload: MinimumWageTableI }
interface SetModalClosedAction { type: 'SET_MODAL_CLOSED', payload?: any }
interface SetRequestPendingAction { type: 'SET_REQUEST_PENDING', payload: boolean }
interface SetStateAction { type: 'SET_STATE', payload: USStateAbbreviated }
interface SetCityAction { type: 'SET_CITY', payload: string }
interface SetWageAction { type: 'SET_WAGE', payload: string | number }
interface SetEffectiveDateAction { type: 'SET_EFFECTIVE_DATE', payload: string | Date }
interface SetCalOpenAction { type: 'SET_CAL_OPEN', payload: boolean }
interface SetRequestPendingAction { type: 'SET_REQUEST_PENDING', payload: boolean }
interface MinimumWageAddedAction { type: 'MINIMUM_WAGE_ADDED', payload?: any }


export type MinimumWageReducerAction =
  SetRowsAction |
  SetSelectedRowAction |
  SetFilteredStateAction |
  SetAddModalOpenAction |
  SetEditModalOpenAction |
  SetDeleteModalOpenAction |
  SetModalClosedAction |
  SetRequestPendingAction |
  SetStateAction |
  SetCityAction |
  SetWageAction |
  SetEffectiveDateAction |
  SetCalOpenAction |
  SetRequestPendingAction |
  MinimumWageAddedAction |
  SetSelectedRowAction


export const reducer = (state: MinimumWageStateI, action: MinimumWageReducerAction): MinimumWageStateI => {
  const { type } = action

  if (type === 'SET_ROWS') return { ...state, rows: action.payload }
  if (type === 'SET_SELECTED_ROW') return { ...state, selectedRow: action.payload }
  if (type === 'SET_FILTERED_STATE') return { ...state, filteredState: action.payload }
  if (type === 'SET_ADD_MODAL_OPEN') return { ...state, modal: { open: true, name: 'ADD_WAGE', form: state.modal.form } }
  if (type === 'SET_EDIT_MODAL_OPEN') {
    return {
      ...state,
      selectedRow: action.payload,
      modal: {
        open: true,
        name: 'EDIT_WAGE',
        form: {
          state: action.payload.state,
          city: action.payload.city,
          minimum_wage: parseFloat(action.payload.minimum_wage.toString()).toFixed(2),
          effective_date: action.payload.effective_date,
          showCal: false
        }
      }
    }
  }
  if (type === 'SET_DELETE_MODAL_OPEN') return { ...state, selectedRow: action.payload, modal: { open: true, name: 'DELETE_WAGE', form: state.modal.form } }
  if (type === 'SET_MODAL_CLOSED') return { ...state, modal: { open: false, name: undefined, form: initialFormState } }
  if (type === 'SET_REQUEST_PENDING') return { ...state, requestPending: action.payload }
  if (type === 'SET_STATE') return { ...state, modal: { ...state.modal, form: { ...state.modal.form, state: action.payload } } }
  if (type === 'SET_CITY') return { ...state, modal: { ...state.modal, form: { ...state.modal.form, city: action.payload } } }
  if (type === 'SET_WAGE') return { ...state, modal: { ...state.modal, form: { ...state.modal.form, minimum_wage: action.payload } } }
  if (type === 'SET_EFFECTIVE_DATE') return { ...state, modal: { ...state.modal, form: { ...state.modal.form, effective_date: action.payload, showCal: false } } }
  if (type === 'SET_CAL_OPEN') return { ...state, modal: { ...state.modal, form: { ...state.modal.form, showCal: action.payload } } }
  if (type === 'MINIMUM_WAGE_ADDED') return { ...state, dbUpdated: true, modal: { ...state.modal, form: { ...state.modal.form, city: '', minimum_wage: '', effective_date: new Date(), showCal: false } } }
  return state
}
